module.exports = __webpack_public_path__ + "static/media/France.d5ac58cd.jpg";